export enum RewardExpiryEnum {
  REPETITION_TIME_MONTHLY = "repetition_time:monthly",
  REPETITION_TIME_ANNUALLY = "repetition_time:annually",
  DURATION_TRANSACTION_TIME = "duration:transaction_time",
  DURATION_REGISTRATION_TIME = "duration:registration_time",
  EXACT_DATE = "exact_date",
}

export default RewardExpiryEnum;
